// The brand configs store their marketing site without a scheme ("www.bitcashier.io"), which is
// what React put straight into `href` — making it a RELATIVE url, so the footer link navigated to
// /www.bitcashier.io inside the dashboard instead of leaving it. Anything that renders a
// configured address as a link goes through here.
export const externalUrl = (url) => {
  const trimmed = (url ?? "").trim();
  if (!trimmed) return null;
  return /^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`;
};
